export const DATA_ANALYST_ROLE_PROMO_FF = 'call-intelligence:enable-data-analyst-role-promo';
export const DATA_ANALYST_CAMPAIGN_END_FF = 'call-intelligence:data-analyst-promo-campaign-end';
export const DATA_ANALYST_ROLE_HELP_LINK = 'https://www.weavehelp.com/weavehelp/article/see-your-user-role';
export const DATA_ANALYST_PROMO_MAX_DISPLAY_DAYS = 7;
export const DATA_ANALYST_ROLE_NAME = 'Data Analyst';

export const TSS_HELP_LINK =
  'https://www.weavehelp.com/weavehelp/article/call-intelligence#Active_Opportunities_-_Turn_Missed_Calls_into_Booked_Appointments';

export const CSV_EXPORT_HELP_LINK =
  'https://www.weavehelp.com/weavehelp/article/call-intelligence-all-call-recordings-tab#Downloading_Call_Intelligence_Data';

export const TSS_IN_APP_BANNER_FF = 'call-intel:in-app-banner:tss:enable';
export const TSS_IN_APP_BANNER_BETA_VARIANT_FF = 'call-intel:in-app-banner:tss:beta-variant';
export const CALL_INTEL_CSV_EXPORT_BANNER_FF = 'enable-call-intel-csv-export';

export const CALL_INSIGHT_SUMMARY_WRITEBACK_BANNER_FF =
  'call-intel:in-app-banner:call-insight-summary-writeback:enable';
export const CALL_INSIGHT_SUMMARY_WRITEBACK_BANNER_BETA_VARIANT_FF =
  'call-intel:in-app-banner:call-insight-summary-writeback:beta-variant';

export const AUTO_ASSIGN_TASK_SETTINGS_BANNER_FF = 'call-intel:in-app-banner:auto-assign-tasks-settings:enable';
